export const BRAND = {
    name: "Netfotech Solutions",
    tagline: "Turn Ideas Into Reality",
    logo: "https://customer-assets.emergentagent.com/job_immersive-3d-hub-6/artifacts/siwcnpkl_Netfotech%20Logo%20250%20Brg%20remove.png",
    logoSolid:
        "https://customer-assets.emergentagent.com/job_immersive-3d-hub-6/artifacts/i9peqzsy_Netfotech-Logo-png-400x322.png",
    email: "info@netfotech.in",
    emailSales: "sales@netfotech.in",
    phone: "+91-8446444464",
    website: "www.netfotech.in",
    headOffice: "World Trade Center, Kharadi, Pune, Maharashtra – 411014. INDIA",
    branchOffices: [
        "Kolkata",
        "Gurgaon",
        "Bangalore",
        "Dehradun",
        "Nagpur",
        "Goa",
        "Jaipur",
        "Wyoming",
        "London",
    ],
    social: {
        linkedin: "https://linkedin.com",
        twitter: "https://twitter.com",
        youtube: "https://youtube.com",
    },
};

export const NAV = [
    { label: "Home", to: "/" },
    { label: "About Us", to: "/about" },
    { label: "Services", to: "/services" },
    { label: "Products & Solutions", to: "/products" },
    { label: "Industries", to: "/industries" },
    { label: "Case Studies", to: "/case-studies" },
    { label: "Resources", to: "/resources" },
    { label: "Careers", to: "/careers" },
    { label: "Contact", to: "/contact" },
];

export const INDUSTRIES = [
    {
        id: "healthcare",
        name: "Healthcare",
        tagline: "Secure, AI-assisted patient care platforms.",
        image:
            "https://images.pexels.com/photos/5452301/pexels-photo-5452301.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        points: ["EHR modernization", "Telehealth platforms", "Clinical AI copilots", "HIPAA-ready data"],
    },
    {
        id: "bfsi",
        name: "BFSI",
        tagline: "Resilient digital banking and fraud analytics.",
        image:
            "https://images.pexels.com/photos/10653885/pexels-photo-10653885.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        points: ["Digital onboarding", "Fraud detection", "Core banking integrations", "Regulatory reporting"],
    },
    {
        id: "retail",
        name: "Retail",
        tagline: "Personalized, omni-channel commerce experiences.",
        image:
            "https://images.unsplash.com/photo-1763532424028-c3a8d2bd55a9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjByZXRhaWwlMjB0ZWNobm9sb2d5JTIwZGFya3xlbnwwfHx8fDE3NzcyODM1NDV8MA&ixlib=rb-4.1.0&q=85",
        points: ["Unified commerce", "Personalization engine", "Store ops analytics", "Loyalty ecosystems"],
    },
    {
        id: "manufacturing",
        name: "Manufacturing",
        tagline: "Smart factories with predictive intelligence.",
        image:
            "https://images.pexels.com/photos/19233057/pexels-photo-19233057.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        points: ["IIoT telemetry", "Predictive maintenance", "Digital twins", "Production intelligence"],
    },
    {
        id: "logistics",
        name: "Logistics & Supply Chain",
        tagline: "Real time visibility across your supply network.",
        image:
            "https://images.pexels.com/photos/5860937/pexels-photo-5860937.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        points: ["Route optimization", "Warehouse automation", "Fleet telematics", "Control towers"],
    },
    {
        id: "education",
        name: "Education",
        tagline: "Adaptive learning ecosystems for institutions.",
        image:
            "https://images.pexels.com/photos/7743256/pexels-photo-7743256.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        points: ["LMS modernization", "Student analytics", "Adaptive learning", "Campus automation"],
    },
    {
        id: "government",
        name: "Government & Public Sector",
        tagline: "Secure citizen services at national scale.",
        image:
            "https://images.unsplash.com/photo-1619654484176-f8648556ce15?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwyfHxnb3Zlcm5tZW50JTIwYnVpbGRpbmclMjBtb2Rlcm4lMjBkYXJrfGVufDB8fHx8MTc3NzI4MzU1MXww&ixlib=rb-4.1.0&q=85",
        points: ["Citizen portals", "e-Governance", "Secure data exchange", "Identity systems"],
    },
];

export const SERVICE_CATEGORIES = [
    {
        id: "digital-transformation",
        num: "01",
        name: "Digital Transformation",
        icon: "Rocket",
        tagline:
            "Empowering enterprises to evolve into intelligent, agile, and sustainable digital businesses.",
        offerings: [
            {
                id: "ai-first-modernization",
                title: "AI-First Enterprise Modernization",
                caseStudyIds: ["cs-healthcare-ai", "cs-mfg-predict"],
                desc:
                    "Fundamentally redesign technology architecture and business processes with AI as the central nervous system not just another tool.",
                offers: [
                    "AI Maturity Assessment & Roadmapping",
                    "Target Operating Model (TOM) Design for AI",
                    "Data Fabric Architecture",
                    "Legacy System Modernization with AI",
                ],
                benefits: [
                    "30-40% operational efficiency via predictive & prescriptive analytics",
                    "Faster innovation cycles embedding AI into product lifecycles",
                    "New AI powered revenue streams",
                    "Future-proofed IT estate resilient to disruption",
                ],
            },
            {
                id: "intelligent-automation",
                title: "Intelligent Automation (RPA + AI)",
                caseStudyIds: ["cs-bfsi-fraud", "cs-mfg-predict"],
                desc:
                    "End-to-end business process transformation combining RPA with Machine Learning, NLP, and Computer Vision.",
                offers: [
                    "Process Discovery & Mining",
                    "Cognitive Automation for unstructured documents",
                    "Hyperautomation (UiPath, Automation Anywhere, Power Automate)",
                    "Automation Center of Excellence Setup",
                ],
                benefits: [
                    "60-80% reduction in process cycle times",
                    "Near-zero error rates, improving compliance",
                    "Upskilled workforce freed from repetition",
                    "Significant operational cost savings",
                ],
            },
            {
                id: "genai-cx-ux",
                title: "CX/UX Strategy powered by GenAI",
                caseStudyIds: ["cs-healthcare-ai"],
                desc:
                    "Hyper-personalized, intuitive, adaptive customer and employee experiences with Generative AI at the core.",
                offers: [
                    "GenAI powered Journey Mapping",
                    "Conversational AI & Chatbot Development",
                    "Real time Personalization Engines",
                    "Employee Experience (EX) Platforms",
                ],
                benefits: [
                    "Up to 30% lift in CSAT / NPS",
                    "50% fewer support tickets via intelligent self-service",
                    "Higher conversion and lifetime value",
                    "Greater employee productivity",
                ],
            },
            {
                id: "esg-sustainability",
                title: "ESG Tech & Sustainability Analytics",
                desc:
                    "Technology for ESG data collection, analysis, reporting and operational optimization with measurable footprint reduction.",
                offers: [
                    "ESG Data Platform Implementation",
                    "Carbon Accounting (Scope 1/2/3)",
                    "Green IoT Integration",
                    "Sustainability Performance Dashboards (GRI, SASB)",
                ],
                benefits: [
                    "Regulatory compliance and audit readiness",
                    "Cost savings via energy & resource optimization",
                    "Stronger brand with ESG-focused investors",
                    "Data-driven long term sustainability strategy",
                ],
            },
            {
                id: "agile-change",
                title: "Agile Transformation & Change Management",
                desc:
                    "Beyond Agile ceremonies a culture of continuous improvement, collaboration and rapid response to change.",
                offers: [
                    "Enterprise Agile Coaching (SAFe, LeSS, Scrum@Scale)",
                    "DevOps & SRE Culture Integration",
                    "Change Impact Analysis & Comms Strategy",
                    "Digital Fluency Upskilling Programs",
                ],
                benefits: [
                    "50-60% faster time-to-market",
                    "Higher engagement, lower turnover",
                    "Better project success & alignment",
                    "Organizational resilience to change",
                ],
            },
        ],
    },
    {
        id: "cloud-infrastructure",
        num: "02",
        name: "Cloud & Infrastructure",
        icon: "Cloud",
        tagline:
            "Accelerating cloudnative journeys with scalable, secure, and cost efficient infrastructure.",
        offerings: [
            {
                id: "cloud-migration",
                title: "Cloud Migration & Modernization",
                caseStudyIds: ["cs-gov-citizen"],
                desc:
                    "End-to-end strategy and execution to move legacy workloads to Azure, AWS or GCP and modernize them on the way.",
                offers: [
                    "Cloud Readiness & TCO Assessment",
                    "Lift-and-Shift Rehosting",
                    "Application Refactoring / Re-architecting",
                    "Database Modernization",
                    "post migration Optimization",
                ],
                benefits: [
                    "Up to 40% lower IT infra costs",
                    "Better business continuity & DR",
                    "Scale on demand without over-provisioning",
                    "Access to native AI / analytics innovation",
                ],
            },
            {
                id: "cloud-native",
                title: "Cloud-Native Application Development",
                caseStudyIds: ["cs-gov-citizen"],
                desc:
                    "Design and build resilient, scalable, future-proof applications using cloud-native principles, microservices and serverless.",
                offers: [
                    "Microservices Architecture Design",
                    "API-First Development",
                    "Serverless-First Development",
                    "event driven Architecture",
                ],
                benefits: [
                    "Faster time-to-market with agile teams",
                    "Unmatched scalability & resilience",
                    "Reduced ops overhead via managed services",
                    "Continuous innovation without full redeploys",
                ],
            },
            {
                id: "kubernetes",
                title: "Kubernetes Orchestration & Containerization",
                caseStudyIds: ["cs-gov-citizen"],
                desc:
                    "enterprise grade Kubernetes platforms that automate deployment, scaling and management of containerized applications.",
                offers: [
                    "Containerization Strategy (Docker)",
                    "Managed Kubernetes (AKS, EKS, GKE)",
                    "GitOps & Continuous Deployment",
                    "24/7 Cluster Operations & Security",
                ],
                benefits: [
                    "True portability across clouds and on-prem",
                    "Higher resource utilization via auto-scaling",
                    "Declarative, self-healing operations",
                    "Accelerated developer productivity",
                ],
            },
            {
                id: "edge-serverless",
                title: "Edge Computing & Serverless Architecture",
                desc:
                    "Extend the cloud to the edge for low latency processing; use serverless for automatic, cost efficient scale.",
                offers: [
                    "Edge Strategy & Architecture",
                    "IoT Edge Platforms (AWS IoT Greengrass, Azure IoT Edge)",
                    "Serverless Application Development (FaaS)",
                    "Hybrid Edge-Cloud Data Sync",
                ],
                benefits: [
                    "Near Real time decisions at the edge",
                    "Lower bandwidth costs",
                    "Zero server management",
                    "Virtually infinite scalability",
                ],
            },
            {
                id: "iac-devops",
                title: "Infrastructure as Code & DevOps Automation",
                caseStudyIds: ["cs-gov-citizen"],
                desc:
                    "Automate the entire infrastructure lifecycle with code  consistent, repeatable, fast, and drift-free.",
                offers: [
                    "IaC (Terraform, AWS CDK, Azure Bicep)",
                    "CI/CD (Azure DevOps, Jenkins, GitLab CI)",
                    "Configuration Management (Ansible, Chef, Puppet)",
                    "Internal Developer Platform",
                ],
                benefits: [
                    "Faster, repeatable deployments",
                    "Codified, version-controlled compliance",
                    "DR in minutes, not days",
                    "Self-service for developers",
                ],
            },
            {
                id: "devsecops-sre",
                title: "DevSecOps & SRE Enablement",
                caseStudyIds: ["cs-gov-citizen", "cs-bfsi-fraud"],
                desc:
                    "Security embedded across the lifecycle with SRE practices for exceptionally reliable software systems.",
                offers: [
                    "DevSecOps Maturity Assessment",
                    "Secure CI/CD (SAST, DAST, SCA, container scans)",
                    "SRE Setup (SLOs, Error Budgets, toil reduction)",
                    "Observability (Prometheus, Grafana, ELK)",
                ],
                benefits: [
                    "Shift-left security reduces cost & risk",
                    "Provable 99.95%+ uptime with SLOs",
                    "Lower operational toil",
                    "Faster mean-time-to-resolution",
                ],
            },
        ],
    },
    {
        id: "cybersecurity",
        num: "03",
        name: "Cybersecurity & Risk",
        icon: "ShieldCheck",
        tagline: "Safeguarding digital assets with proactive,  AI driven security frameworks.",
        offerings: [
            {
                id: "Zero trust",
                title: "Zero trust Security Architecture",
                caseStudyIds: ["cs-gov-citizen", "cs-bfsi-fraud"],
                desc:
                    "Move from castle and moat to continuously-verified Zero Trust identity-centric, micro-segmented, and SASE-ready.",
                offers: [
                    "Zero trust Maturity Assessment (NIST)",
                    "Identity-Centric Perimeter Design",
                    "Micro-Segmentation Strategy",
                    "SASE Implementation",
                ],
                benefits: [
                    "Dramatically reduced attack surface",
                    "Secure direct-to-app for hybrid workforces",
                    "Stronger compliance posture",
                    "Contained lateral movement",
                ],
            },
            {
                id: "soc-aaas",
                title: "SOC-as-a-Service with AI Threat Detection",
                caseStudyIds: ["cs-bfsi-fraud"],
                desc:
                    "A 24/7 AI powered SOC that hunts threats, detects anomalies in Real time, and responds at machine speed.",
                offers: [
                    "Managed Detection and Response (MDR)",
                    " AI driven Security Analytics (UEBA)",
                    "SOAR for automated response playbooks",
                    "Threat Intelligence Integration",
                ],
                benefits: [
                    "24/7 monitoring without in-house SOC cost",
                    "Faster MTTD & MTTR",
                    "Proactive hidden-threat hunting",
                    "Reduced alert fatigue",
                ],
            },
            {
                id: "iam",
                title: "Identity & Access Management (IAM)",
                desc:
                    "The cornerstone of Zero Trust  right users, right access, right resources, right time.",
                offers: [
                    "SSO & Multi-Factor Authentication",
                    "Privileged Access Management (PAM)",
                    "Identity Governance & Administration (IGA)",
                    "Customer IAM (CIAM)",
                ],
                benefits: [
                    "One-click access with stronger security",
                    "Lower breach risk from stolen credentials",
                    "Automated compliance & attestation",
                    "Lower IT helpdesk costs",
                ],
            },
            {
                id: "compliance-automation",
                title: "Compliance Automation (GDPR, HIPAA, ISO)",
                caseStudyIds: ["cs-healthcare-ai", "cs-bfsi-fraud"],
                desc:
                    "Continuous compliance, not point in time audits evidence collected and monitored automatically.",
                offers: [
                    "Compliance Gap Analysis (SOC 2, ISO 27001, GDPR, HIPAA, PCI-DSS)",
                    "Automated Policy Management",
                    "Continuous Control Monitoring",
                    "Real time Compliance Dashboards",
                ],
                benefits: [
                    "Faster, cheaper audits",
                    "Up to 70% less manual compliance effort",
                    "Continuous compliance posture",
                    "Proactive risk identification",
                ],
            },
            {
                id: "pentest-vm",
                title: "Penetration Testing & Vulnerability Management",
                desc:
                    "Adversary perspective testing across apps, networks and cloud with ongoing vulnerability management.",
                offers: [
                    "Application (web, mobile, API) Pentesting",
                    "Network & Infrastructure Pentesting",
                    "Cloud Security Posture Management (CSPM)",
                    "Vulnerability Management as a Service",
                ],
                benefits: [
                    "Remediate criticals before attackers find them",
                    "Risk-prioritized security effort",
                    "Meet independent testing mandates",
                    "Brand protection from breaches",
                ],
            },
        ],
    },
    {
        id: "data-ai",
        num: "04",
        name: "Data & AI",
        icon: "Sparkles",
        tagline: "Turning data into decisions with scalable AI and modern data architectures.",
        offerings: [
            {
                id: "data-lakehouse",
                title: "Data Engineering & Lakehouse Architecture",
                caseStudyIds: ["cs-bfsi-fraud", "cs-mfg-predict"],
                desc:
                    "Unified, scalable data foundations across structured and unstructured data for analytics and advanced AI.",
                offers: [
                    "Lakehouse (Delta, Iceberg, Databricks, Snowflake)",
                    "Cloud Data Migration (Snowflake, BigQuery, Synapse)",
                    "Real time Pipelines (Kafka, Spark Streaming)",
                    "Data Catalog & Discovery",
                ],
                benefits: [
                    "Unified enterprise data view",
                    "50-70% lower analytics latency",
                    "Cost savings from consolidated platforms",
                    "Ready-to-use curated datasets for AI",
                ],
            },
            {
                id: "predictive-modelops",
                title: "Predictive Analytics & ML ModelOps",
                desc:
                    "Operationalize ML from experimentation to production with automated model management and retraining.",
                offers: [
                    "End-to-End ML Pipeline Development",
                    "Predictive Models (Scikit-learn, TensorFlow, PyTorch)",
                    "MLOps (MLflow, Kubeflow, Azure ML)",
                    "Model Drift & Performance Monitoring",
                ],
                benefits: [
                    "Faster time-to-value for AI",
                    "Higher accuracy via continuous retraining",
                    "Lower operational risk via governance",
                    "Hundreds of models in production",
                ],
            },
            {
                id: "genai-integration",
                title: "GenAI Integration for Enterprise Workflows",
                caseStudyIds: ["cs-healthcare-ai"],
                desc:
                    "Safely integrate Generative AI into core processes with enterprise grade security and compliance.",
                offers: [
                    "Enterprise Copilot Development",
                    "Retrieval-Augmented Generation (RAG)",
                    "Platform Strategy (Azure OpenAI, Bedrock, Vertex AI)",
                    "Document Intelligence Automation",
                ],
                benefits: [
                    "40-60% productivity gains",
                    "Better decisions from unstructured data",
                    "Smarter, always-on customer service",
                    "Faster innovation & knowledge discovery",
                ],
            },
            {
                id: "responsible-ai",
                title: "Responsible AI Governance & Explainability",
                desc:
                    "Governance frameworks that keep AI transparent, fair, compliant, and aligned to organizational values.",
                offers: [
                    "AI Governance Framework Design",
                    "Explainability (SHAP, LIME)",
                    "Data Lineage & Provenance",
                    "AI Risk Management",
                ],
                benefits: [
                    "Ready for emerging AI regulations",
                    "Stakeholder trust via transparency",
                    "Lower legal / reputational risk",
                    "Better models via decision insights",
                ],
            },
            {
                id: "ai-ethics",
                title: "AI Ethics, Bias Mitigation & Fairness",
                desc:
                    "Proactively identify and mitigate bias; embed fairness, accountability and ethics into AI delivery.",
                offers: [
                    "Bias Assessment & Auditing",
                    "Fairness-Aware Model Development",
                    "AI Ethics Advisory & Training",
                    "Algorithmic Impact Assessments",
                ],
                benefits: [
                    "Equitable outcomes across user groups",
                    "Reputation as an ethical AI leader",
                    "Lower discrimination risk",
                    "Future-proofed against ethics standards",
                ],
            },
        ],
    },
    {
        id: "enterprise-platforms",
        num: "05",
        name: "Enterprise Platforms & Integration",
        icon: "Cpu",
        tagline: "Modernizing core systems and enabling composable, connected enterprises.",
        offerings: [
            {
                id: "erp-crm",
                title: "ERP/CRM Upgrades & Cloud Migration",
                desc:
                    "Transform legacy enterprise systems into agile, cloud-based platforms that drive efficiency and Real time insight.",
                offers: [
                    "Cloud Migration & S/4HANA Transformation",
                    "CRM (Salesforce, Dynamics 365)",
                    "System Integration & Data Unification",
                    "Mobile Enablement & UX Modernization",
                ],
                benefits: [
                    "30-40% lower operational costs",
                    "True 360° customer view",
                    "Real time BI for faster decisions",
                    "Higher user adoption via modern UX",
                ],
            },
            {
                id: "api-led",
                title: "API-Led Integration & Microservices",
                caseStudyIds: ["cs-gov-citizen"],
                desc:
                    "API-first architectures unlocking legacy data and enabling seamless, reusable connectivity.",
                offers: [
                    "API Strategy & Governance",
                    "API Gateway (MuleSoft, APIM, Apigee)",
                    "Legacy System Modernization",
                    "Developer Portals & API Marketplaces",
                ],
                benefits: [
                    "70% faster integration delivery",
                    "Loose coupling and system agility",
                    "New revenue via API monetization",
                    "Centralized security & governance",
                ],
            },
            {
                id: "microservices",
                title: "Microservices Architecture Design",
                caseStudyIds: ["cs-gov-citizen"],
                desc:
                    "Decompose monoliths into independent services that enable faster innovation and tech diversity.",
                offers: [
                    "Microservices Discovery & Decomposition",
                    "Domain-Driven Design (DDD)",
                    "event driven Architecture",
                    "Service Mesh (Istio, Linkerd)",
                ],
                benefits: [
                    "Independent scaling per service",
                    "Faster, team-owned feature delivery",
                    "Tech flexibility per service",
                    "Better fault isolation",
                ],
            },
            {
                id: "low-code",
                title: "Low-Code / No-Code Enablement",
                desc:
                    "Empower business users to build apps and automate processes with minimal IT dependency.",
                offers: [
                    "Platform Selection (Power Platform, Mendix, OutSystems)",
                    "Center of Excellence Setup",
                    "Citizen Developer Training",
                    "Pro-Code Extension Engineering",
                ],
                benefits: [
                    "10x faster app development",
                    "Reduced IT backlog",
                    "Lower development costs",
                    "Better business-IT alignment",
                ],
            },
            {
                id: "iot-digital-twins",
                title: "IoT Platforms & Digital Twins",
                caseStudyIds: ["cs-mfg-predict"],
                desc:
                    "Dynamic virtual replicas of assets, processes and systems for simulation, analysis and optimization.",
                offers: [
                    "IoT Platform Implementation (Azure IoT, AWS IoT, ThingWorx)",
                    "Sensor Integration & Data Ingestion",
                    "3D Digital Twin Development",
                    "Predictive Analytics Integration",
                ],
                benefits: [
                    "30% less downtime via predictive maintenance",
                    "Optimized ops via scenario simulation",
                    "Better product quality",
                    "Remote asset management at scale",
                ],
            },
        ],
    },
    {
        id: "quantum",
        num: "06",
        name: "Quantum Computing",
        icon: "Atom",
        tagline: "future proofing enterprises with quantum innovation and hybrid computing.",
        offerings: [
            {
                id: "quantum-algorithms",
                title: "Quantum Algorithm Design",
                desc:
                    "Specialized quantum algorithms for optimization, cryptography, simulation and machine learning.",
                offers: [
                    "Quantum Optimization (portfolio, logistics, routing)",
                    "Quantum-Resistant Cryptography & QKD",
                    "Molecular Simulation (drug discovery, materials)",
                    "Quantum Machine Learning",
                ],
                benefits: [
                    "100-1000x speedup on certain problems",
                    "Future-proof cryptographic security",
                    "Breakthroughs in materials & drugs",
                    "Edge in solving once-intractable problems",
                ],
            },
            {
                id: "quantum readiness",
                title: "Quantum Readiness Assessment",
                desc:
                    "Identify high-value enterprise use cases where quantum can deliver transformative impact.",
                offers: [
                    "Quantum Use Case Identification",
                    "Technical Feasibility Analysis",
                    "ROI & Business Case Development",
                    "Quantum Talent Gap Assessment",
                ],
                benefits: [
                    "Strategic direction for quantum investment",
                    "Evidence-based risk mitigation",
                    "Optimized resource allocation",
                    "Early-mover industry advantage",
                ],
            },
            {
                id: "hybrid-quantum",
                title: "Hybrid Quantum-Classical Integration",
                desc:
                    "Practical hybrid solutions combining quantum with your classical infrastructure real value from day one.",
                offers: [
                    "Hybrid Algorithm Development",
                    "Quantum API Integration",
                    "Quantum Simulator Deployment",
                    "Intelligent Workflow Orchestration",
                ],
                benefits: [
                    "Adoption without replacing classical infra",
                    "Lower dev risk via simulation",
                    "Cost-effective experimentation",
                    "Seamless simulator-to-hardware scale",
                ],
            },
            {
                id: "quantum-partnerships",
                title: "Partnerships IBM Q, Azure Quantum, Google Quantum AI",
                desc:
                    "Access cutting-edge quantum hardware, software and expertise via strategic partnerships.",
                offers: [
                    "Multi-Platform Access Strategy",
                    "Hardware Selection Advisory (superconducting, trapped-ion, photonic)",
                    "Partner Ecosystem Integration",
                    "Dedicated Quantum Access (managed)",
                ],
                benefits: [
                    "Access to quantum hardware without CapEx",
                    "Expert guidance across platforms",
                    "Faster time-to-value",
                    "Future-proof technology choices",
                ],
            },
        ],
    },
    {
        id: "ai-agents",
        num: "07",
        name: "AI Agent Services",
        icon: "Bot",
        tagline: "Deploying autonomous, intelligent agents to drive productivity and decision-making.",
        offerings: [
            {
                id: "autonomous-agents",
                title: "Autonomous AI Agents",
                caseStudyIds: ["cs-healthcare-ai", "cs-bfsi-fraud"],
                desc:
                    "Specialized AI agents that autonomously execute complex tasks, make data-driven decisions, and handle routine work 24/7.",
                offers: [
                    "Customer Support Agents",
                    "IT Operations Agents",
                    "Business Process Agents",
                    "Sales & Marketing Agents",
                ],
                benefits: [
                    "24/7 operation without human in loop",
                    "70-80% less routine-task time",
                    "Consistent, policy-compliant execution",
                    "Elastic capacity for spikes",
                ],
            },
            {
                id: "multi-agent",
                title: "Multi-Agent Orchestration",
                desc:
                    "Systems where specialized agents collaborate, communicate and coordinate on complex, multi-capability problems.",
                offers: [
                    "Workflow Design & Agent Coordination",
                    "Agent-to-Agent Communication Protocols",
                    "Conflict Resolution Systems",
                    "Dynamic Task Allocation",
                ],
                benefits: [
                    "Holistic automation of multi-step workflows",
                    "Better problem-solving via specialists",
                    "Resilience via redundant capabilities",
                    "Optimized resource utilization",
                ],
            },
            {
                id: "agentops",
                title: "AgentOps Monitoring, Retraining, Governance",
                desc:
                    "Platforms to continuously monitor, retrain and govern your AI agent ecosystem for reliability, compliance, improvement.",
                offers: [
                    "Agent Performance Monitoring",
                    "Automated Retraining Pipelines",
                    "Governance & Compliance Frameworks",
                    "Agent Lifecycle Management",
                ],
                benefits: [
                    "Proactive remediation of drift",
                    "Continuous agent improvement",
                    "Audit-grade regulatory compliance",
                    "Centralized multi-agent management",
                ],
            },
            {
                id: "domain-agents",
                title: "Domain-Specific Agents",
                caseStudyIds: ["cs-healthcare-ai", "cs-bfsi-fraud", "cs-mfg-predict"],
                desc:
                    "Pre-built, industry-trained autonomous agents that understand your sector's language, regulations and workflows.",
                offers: [
                    "BFSI fraud, compliance, wealth advisory",
                    "Healthcare clinical decision support, coding",
                    "Manufacturing predictive maintenance, QC",
                    "Utilities outage prediction, grid optimization",
                ],
                benefits: [
                    "Rapid deployment with pre-trained models",
                    "Higher decision accuracy",
                    "Lower TCO with purpose-built solutions",
                    "Built-in regulatory compliance",
                ],
            },
        ],
    },
    {
        id: "blockchain",
        num: "08",
        name: "Blockchain & Web3",
        icon: "Blocks",
        tagline:
            "Decentralized architecture, verifiable smart contracts, and enterprise tokenization platforms.",
        offerings: [
            {
                id: "enterprise-blockchain",
                title: "Enterprise Blockchain & Distributed Ledgers",
                desc:
                    "Permissioned and public blockchain networks engineered for cross-enterprise transparency, auditability, and trustless collaboration.",
                offers: [
                    "Consortium & Private Network Architecture (Hyperledger, Corda)",
                    "Cross-Chain Interoperability & Bridges",
                    "Consensus Mechanism Design & Optimization",
                    "Enterprise Node Infrastructure & Staking",
                ],
                benefits: [
                    "Tamper-proof audit trails and data provenance",
                    "Frictionless multi-party transaction settlement",
                    "Automated compliance via immutable logs",
                    "Reduced intermediary fees and operational overhead",
                ],
            },
            {
                id: "smart-contracts",
                title: "Smart Contract Engineering & Security Audits",
                desc:
                    "High-integrity smart contract development with rigorous formal verification, penetration testing, and automated security audits.",
                offers: [
                    "Solidity, Rust & Move Smart Contract Development",
                    "Formal Verification & Static Analysis",
                    "Vulnerability Assessment & Gas Optimization",
                    "Automated Bug Bounty & Exploit Simulation",
                ],
                benefits: [
                    "Zero-critical vulnerability deployment assurance",
                    "Up to 40% gas fee optimization for contract calls",
                    "Resilient deterministic business logic execution",
                    "Audit-grade reports meeting institutional standards",
                ],
            },
            {
                id: "rwa-tokenization",
                title: "Real-World Asset (RWA) Tokenization",
                desc:
                    "Transform illiquid physical and financial assets into secure, fractionalized, and compliant digital tokens on modern ledgers.",
                offers: [
                    "Real Estate, Debt & Equity Tokenization Frameworks",
                    "ERC-3643 & Compliance-Wrapped Token Standards",
                    "Secondary Market Liquidity & Custody Integration",
                    "Automated Dividend & Yield Distribution Contracts",
                ],
                benefits: [
                    "Democratized fractional ownership and liquidity",
                    "Near-instant 24/7 settlement without clearing delays",
                    "Built-in regulatory compliance (KYC/AML token rules)",
                    "Lower administrative costs for capital formation",
                ],
            },
            {
                id: "decentralized-identity",
                title: "Decentralized Identity (DID) & Zero-Knowledge",
                desc:
                    "Privacy-preserving identity solutions empowering users and enterprises with verifiable credentials and ZK-proof verification.",
                offers: [
                    "W3C Verifiable Credentials & SSI Architecture",
                    "Zero-Knowledge Proof (zk-SNARKs / zk-STARKs) Implementations",
                    "Self-Sovereign Identity Wallets for Enterprise",
                    "Selective Disclosure & Privacy-Preserving KYC",
                ],
                benefits: [
                    "Zero liability for centralized credential storage leaks",
                    "Instant reusable identity verification across ecosystems",
                    "Complete user privacy with mathematical verification",
                    "Full GDPR and CCPA data minimization compliance",
                ],
            },
        ],
    },
    {
        id: "platform-engineering",
        num: "09",
        name: "Platform Engineering & DevSecOps",
        icon: "Layers",
        tagline:
            "Internal developer platforms, automated GitOps pipelines, and resilient SRE operations.",
        offerings: [
            {
                id: "internal-developer-platforms",
                title: "Internal Developer Platforms (IDP)",
                desc:
                    "Build self-service developer portals that standardize tooling, streamline onboarding, and eliminate cognitive friction for engineering teams.",
                offers: [
                    "Backstage & Port Developer Portal Implementations",
                    "Golden Paths & Scaffolded Service Templates",
                    "Self-Service Cloud Environment Provisioning",
                    "Developer Experience (DevEx) & Velocity Analytics",
                ],
                benefits: [
                    "70% reduction in developer onboarding time",
                    "Elimination of ticket-driven infra requests",
                    "Consistent architecture and security governance",
                    "Higher developer satisfaction and retention",
                ],
            },
            {
                id: "gitops-iac",
                title: "GitOps & Declarative Infrastructure as Code",
                desc:
                    "Drive infrastructure automation and continuous deployment with Git as the single source of truth for all environment configurations.",
                offers: [
                    "Terraform, OpenTofu & Pulumi Enterprise Modules",
                    "ArgoCD & Flux Automated GitOps Deployments",
                    "Policy as Code (OPA / Kyverno / Sentinel)",
                    "Automated Drift Detection & Self-Healing State",
                ],
                benefits: [
                    "Deterministic, auditable environment rollouts",
                    "Instant one-click disaster recovery rollbacks",
                    "Zero manual configuration drift across clouds",
                    "Enforced security guardrails at pull-request time",
                ],
            },
            {
                id: "devsecops-continuous-compliance",
                title: "DevSecOps & Supply Chain Security",
                desc:
                    "Shift security left by baking vulnerability scanning, secret detection, and SBOM verification directly into continuous CI/CD pipelines.",
                offers: [
                    "Automated SAST, DAST, SCA & Secret Scanning",
                    "Software Bill of Materials (SBOM) Generation & Attestation",
                    "SLSA Framework Level 3 Pipeline Hardening",
                    "Container & Kubernetes Image Signing (Cosign)",
                ],
                benefits: [
                    "Vulnerabilities remediated before production deployment",
                    "Defense against software supply chain poisoning",
                    "Continuous regulatory compliance readiness (SOC2, ISO 27001)",
                    "Accelerated release cycles with automated gate approvals",
                ],
            },
            {
                id: "sre-observability",
                title: "Site Reliability Engineering & Observability",
                desc:
                    "enterprise grade reliability engineering combining telemetry instrumentation, chaos engineering, and proactive incident response.",
                offers: [
                    "OpenTelemetry, Prometheus & Grafana Stacks",
                    "SLO / SLI Definition & Error Budget Management",
                    "Chaos Engineering & Fault Injection Testing",
                    "Automated AIOps Incident Triaging & Remediation",
                ],
                benefits: [
                    "99.99%+ platform uptime with reduced MTTR",
                    "Clear data-driven release vs. reliability trade-offs",
                    "Proactive bottleneck identification before customer impact",
                    "Unified single-pane observability across distributed services",
                ],
            },
        ],
    },
];

// Backward-compat: flat "SERVICES" shape used by the Home preview cards.
// Derived from SERVICE_CATEGORIES 6 key services (drops quantum which is category-level on its own).
export const SERVICES = SERVICE_CATEGORIES.map((c) => ({
    id: c.id,
    title: c.name,
    desc: c.tagline,
    bullets: c.offerings.slice(0, 4).map((o) => o.title),
}));

export const PRODUCTS = [
    {
        id: "aspirex",
        title: "AspireX AI Decision Cloud",
        tagline: "Enterprise decision intelligence with explainable AI.",
        features: [
            "Unified data & ML workspace",
            "Agent & copilot framework",
            "Policy-based access control",
            "Model observability & drift",
        ],
    },
    {
        id: "securegrid",
        title: "SecureGrid Zero Trust Platform",
        tagline: "Identity-first security for distributed enterprises.",
        features: [
            "Adaptive MFA & SSO",
            "Micro-segmentation",
            "Continuous threat scoring",
            "Regulatory reporting packs",
        ],
    },
    {
        id: "flowops",
        title: "FlowOps Intelligent Operations Suite",
        tagline: "Workflow automation fused with realtime analytics.",
        features: [
            "Low-code workflow studio",
            "Process mining",
            "SLA command center",
            "Connector marketplace",
        ],
    },
];

export const CASE_STUDIES = [
    {
        id: "cs-bfsi-fraud",
        industry: "BFSI",
        title: "Real time fraud intelligence for a top 10 retail bank",
        summary:
            "Reduced false positives by 62% and blocked ₹480Cr in fraudulent transactions within 9 months of deployment.",
        metrics: [
            { label: "False positives reduced", value: "62%" },
            { label: "Value protected", value: "₹480Cr" },
            { label: "Deployment time", value: "9 mo" },
        ],
        image:
            "https://images.pexels.com/photos/10653885/pexels-photo-10653885.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    },
    {
        id: "cs-healthcare-ai",
        industry: "Healthcare",
        title: "AI triage copilot for a multi-hospital network",
        summary:
            "Brought average ER triage time from 14 to 4 minutes using a HIPAA-ready clinical copilot trained on 2M+ records.",
        metrics: [
            { label: "Triage time", value: "4 min" },
            { label: "Records trained on", value: "2M+" },
            { label: "Hospitals live", value: "27" },
        ],
        image:
            "https://images.pexels.com/photos/5452301/pexels-photo-5452301.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    },
    {
        id: "cs-mfg-predict",
        industry: "Manufacturing",
        title: "Predictive maintenance across 4 smart factories",
        summary:
            "Cut unplanned downtime by 41% and saved $12M annually by streaming 18,000 sensors into a digital twin.",
        metrics: [
            { label: "Downtime reduced", value: "41%" },
            { label: "Annual savings", value: "$12M" },
            { label: "Sensors streamed", value: "18k" },
        ],
        image:
            "https://images.pexels.com/photos/19233057/pexels-photo-19233057.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    },
    {
        id: "cs-gov-citizen",
        industry: "Government",
        title: "National citizen services portal serving 120M users",
        summary:
            "Launched a Zero trust citizen portal handling 9M daily transactions with 99.99% uptime in year one.",
        metrics: [
            { label: "Citizens served", value: "120M" },
            { label: "Daily transactions", value: "9M" },
            { label: "Uptime", value: "99.99%" },
        ],
        image:
            "https://images.unsplash.com/photo-1619654484176-f8648556ce15?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwyfHxnb3Zlcm5tZW50JTIwYnVpbGRpbmclMjBtb2Rlcm4lMjBkYXJrfGVufDB8fHx8MTc3NzI4MzU1MXww&ixlib=rb-4.1.0&q=85",
    },
    {
        id: "cs-bfsi-aml",
        industry: "BFSI",
        title: " AI driven AML platform for a multi-country private bank",
        summary:
            "Cut AML investigation time by 58% and boosted true-positive rate to 81% across six countries using behavioural risk models and a unified alert workbench.",
        metrics: [
            { label: "Investigation time", value: "-58%" },
            { label: "True-positive rate", value: "81%" },
            { label: "Countries live", value: "6" },
        ],
        image:
            "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=1200&q=80",
    },
    {
        id: "cs-healthcare-rpm",
        industry: "Healthcare",
        title: "Remote patient monitoring for a chronic-care network",
        summary:
            "Connected 44,000 chronic-care patients to a predictive RPM platform reducing 30-day readmissions by 34% and flagging 1,200+ early interventions in year one.",
        metrics: [
            { label: "Patients connected", value: "44k" },
            { label: "Readmissions cut", value: "-34%" },
            { label: "Early interventions", value: "1,200+" },
        ],
        image:
            "https://images.pexels.com/photos/7088498/pexels-photo-7088498.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    },
    {
        id: "cs-retail-omni",
        industry: "Retail",
        title: "Omnichannel transformation for a 420-store fashion retailer",
        summary:
            "Unified online, store and mobile commerce on a single platform lifting online conversion by 28% and boosting same-store like-for-like by 11%.",
        metrics: [
            { label: "Conversion lift", value: "+28%" },
            { label: "LFL growth", value: "+11%" },
            { label: "Stores unified", value: "420" },
        ],
        image:
            "https://images.unsplash.com/photo-1441986300917-64674bd600d8?auto=format&fit=crop&w=1200&q=80",
    },
    {
        id: "cs-mfg-quality",
        industry: "Manufacturing",
        title: "Vision-AI quality control for an automotive tier-1 supplier",
        summary:
            "Deployed a fleet of computer-vision quality stations that cut defect escape rate by 72% and reduced manual inspection effort by 18,000 hours/year.",
        metrics: [
            { label: "Defect escape", value: "-72%" },
            { label: "Hours saved/year", value: "18k" },
            { label: "Lines deployed", value: "9" },
        ],
        image:
            "https://images.pexels.com/photos/3846209/pexels-photo-3846209.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    },
    {
        id: "cs-utilities-outage",
        industry: "Utilities",
        title: "AI outage prediction for a national electricity distributor",
        summary:
            "Built a grid-wide outage prediction model reaching 87% precision on 24-hour outage risk cutting unplanned customer-minutes lost by 41%.",
        metrics: [
            { label: "Prediction precision", value: "87%" },
            { label: "CMI reduced", value: "-41%" },
            { label: "Substations modeled", value: "3,400" },
        ],
        image:
            "https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?auto=format&fit=crop&w=1200&q=80",
    },
    {
        id: "cs-legal-docintel",
        industry: "Legal",
        title: "Document intelligence for a global legal services firm",
        summary:
            "Automated contract review, clause extraction and redlining across 2.1M documents delivering a 6x productivity lift for associate lawyers.",
        metrics: [
            { label: "Productivity lift", value: "6x" },
            { label: "Documents processed", value: "2.1M" },
            { label: "Associates onboarded", value: "380" },
        ],
        image:
            "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?auto=format&fit=crop&w=1200&q=80",
    },
];

export const RESOURCES = [
    // --- Blogs (authored on netfotech.in/blogs) ---
    {
        id: "r-agile-bi",
        type: "Blog",
        category: "Data & Analytics",
        title: "Agile in Business Intelligence: faster BI delivery with iterative data modelling",
        summary:
            "Why BI teams are shifting from waterfall to agile initial data analysis, prototype architecture, iterative design-build-test with stakeholder-in-the-loop, and how to handle the usual challenges (data quality, team resistance, large-team communication).",
        content: "Why BI teams are shifting from waterfall to agile initial data analysis, prototype architecture, iterative design-build-test with stakeholder-in-the-loop, and how to handle the usual challenges (data quality, team resistance, large-team communication). Full article body is published at netfotech.in. This extended excerpt explores the problem, the approach and the outcome with practical examples drawn from Netfotech's delivery work across BFSI, healthcare, manufacturing and government.",
        readTime: "7 min",
        author: "Netfotech Practice",
        date: "2025-09-12",
    },
    {
        id: "r-forecast",
        type: "Blog",
        category: "Project Delivery",
        title: "Resource Forecasting: predicting the needs of successful projects",
        summary:
            "A practical look at forecasting people, skills and capacity the single biggest lever for project scheduling, allocation and ‘which projects should we say yes to’ decisions.",
        content: "A practical look at forecasting people, skills and capacity the single biggest lever for project scheduling, allocation and ‘which projects should we say yes to’ decisions. Full article body is published at netfotech.in. This extended excerpt explores the problem, the approach and the outcome with practical examples drawn from Netfotech's delivery work across BFSI, healthcare, manufacturing and government.",
        readTime: "5 min",
        author: "Netfotech Practice",
        date: "2025-08-05",
    },
    {
        id: "r-planning-poker",
        type: "Whitepaper",
        category: "Agile Engineering",
        title: "Agile Estimation using Planning Poker",
        summary:
            "A concise field guide to Planning Poker when it beats traditional estimation, where it breaks down on large backlogs, and how we pair it with Bucket and Affinity estimation inside Scrum@Scale.",
        content: "A concise field guide to Planning Poker when it beats traditional estimation, where it breaks down on large backlogs, and how we pair it with Bucket and Affinity estimation inside Scrum@Scale. Full article body is published at netfotech.in. This extended excerpt explores the problem, the approach and the outcome with practical examples drawn from Netfotech's delivery work across BFSI, healthcare, manufacturing and government.",
        readTime: "11 min",
        author: "Netfotech Agile CoE",
        date: "2025-07-18",
    },
    {
        id: "r-evergreening",
        type: "Report",
        category: "Healthcare & Life Sciences",
        title: "Evergreening of patented drugs: risks, bans and opportunities for Indian makers",
        summary:
            "How recent policy shifts on evergreening are reshaping the IP landscape and the technology opportunity it opens up for Indian pharma in formulations, analytics and digital clinical trials.",
        content: "How recent policy shifts on evergreening are reshaping the IP landscape and the technology opportunity it opens up for Indian pharma in formulations, analytics and digital clinical trials. Full article body is published at netfotech.in. This extended excerpt explores the problem, the approach and the outcome with practical examples drawn from Netfotech's delivery work across BFSI, healthcare, manufacturing and government.",
        readTime: "8 min",
        author: "Netfotech Industry Desk",
        date: "2025-06-22",
    },

    // --- Whitepapers / deep-dives authored by Netfotech practices ---
    {
        id: "r-agent-ops",
        type: "Whitepaper",
        category: "AI & Agents",
        title: "AgentOps: running autonomous AI agents in the enterprise",
        summary:
            "Lifecycle, governance and observability for production AI agents from policy sandboxes and tool-use telemetry to red-teaming and drift detection.",
        content: "Lifecycle, governance and observability for production AI agents from policy sandboxes and tool-use telemetry to red-teaming and drift detection. Full article body is published at netfotech.in. This extended excerpt explores the problem, the approach and the outcome with practical examples drawn from Netfotech's delivery work across BFSI, healthcare, manufacturing and government.",
        readTime: "15 min",
        author: "Netfotech AI Lab",
        date: "2025-10-02",
    },
    {
        id: "r-cloud-migrations",
        type: "Guide",
        category: "Cloud & Infrastructure",
        title: "Cloud Migrations playbook: 6R, 90-day pilots and post migration FinOps",
        summary:
            "How we run cloud migrations end-to-end readiness, TCO, lift-and-shift vs refactor, data & identity, cutover drills, and the FinOps discipline that stops the cloud bill from exploding afterwards.",
        content: "How we run cloud migrations end-to-end readiness, TCO, lift-and-shift vs refactor, data & identity, cutover drills, and the FinOps discipline that stops the cloud bill from exploding afterwards. Full article body is published at netfotech.in. This extended excerpt explores the problem, the approach and the outcome with practical examples drawn from Netfotech's delivery work across BFSI, healthcare, manufacturing and government.",
        readTime: "13 min",
        author: "Netfotech Cloud Practice",
        date: "2025-09-28",
    },
    {
        id: "r-AI ready",
        type: "Whitepaper",
        category: "AI & Transformation",
        title: "The AI ready enterprise: a 2026 blueprint",
        summary:
            "A 28-page playbook covering data foundations, model lifecycle, governance and change management to ship AI safely at enterprise scale.",
        content: "A 28-page playbook covering data foundations, model lifecycle, governance and change management to ship AI safely at enterprise scale. Full article body is published at netfotech.in. This extended excerpt explores the problem, the approach and the outcome with practical examples drawn from Netfotech's delivery work across BFSI, healthcare, manufacturing and government.",
        readTime: "14 min",
        author: "Netfotech Leadership",
        date: "2025-11-15",
    },
    {
        id: "r-market-dynamics",
        type: "Blog",
        category: "Strategy",
        title: "Market dynamics driving technology adoption",
        summary:
            "How macroeconomic pressure, AI commoditisation and regulatory tailwinds are rewriting enterprise tech priorities and the four bets we think CIOs should make now.",
        content: "How macroeconomic pressure, AI commoditisation and regulatory tailwinds are rewriting enterprise tech priorities and the four bets we think CIOs should make now. Full article body is published at netfotech.in. This extended excerpt explores the problem, the approach and the outcome with practical examples drawn from Netfotech's delivery work across BFSI, healthcare, manufacturing and government.",
        readTime: "6 min",
        author: "Netfotech Leadership",
        date: "2025-11-02",
    },
    {
        id: "r-Zero trust-bfsi",
        type: "Guide",
        category: "Cybersecurity",
        title: "Zero trust security for BFSI: a 90-day rollout",
        summary:
            "A regulator-aligned path from perimeter security to identity-first Zero trust specifically engineered for Indian banks and NBFCs under the evolving DPDP and RBI guidelines.",
        content: "A regulator-aligned path from perimeter security to identity-first Zero trust specifically engineered for Indian banks and NBFCs under the evolving DPDP and RBI guidelines. Full article body is published at netfotech.in. This extended excerpt explores the problem, the approach and the outcome with practical examples drawn from Netfotech's delivery work across BFSI, healthcare, manufacturing and government.",
        readTime: "11 min",
        author: "Netfotech SecureGrid",
        date: "2025-10-14",
    },
    {
        id: "r-pilot-to-platform",
        type: "Case Report",
        category: "Healthcare",
        title: "From pilot to platform: scaling AI in hospitals",
        summary:
            "Lessons from operationalising clinical copilots across a 27-hospital network without disrupting care or breaking HIPAA/DPDP compliance.",
        content: "Lessons from operationalising clinical copilots across a 27-hospital network without disrupting care or breaking HIPAA/DPDP compliance. Full article body is published at netfotech.in. This extended excerpt explores the problem, the approach and the outcome with practical examples drawn from Netfotech's delivery work across BFSI, healthcare, manufacturing and government.",
        readTime: "9 min",
        author: "Netfotech Health Practice",
        date: "2025-08-21",
    },
    {
        id: "r-regtech",
        type: "Whitepaper",
        category: "BFSI",
        title: "RegTech 2.0: continuous compliance for BFSI",
        summary:
            "Moving from point in time audits to continuous, evidence-backed compliance with reference architectures for KYC, AML and regulatory reporting.",
        content: "Moving from point in time audits to continuous, evidence-backed compliance with reference architectures for KYC, AML and regulatory reporting. Full article body is published at netfotech.in. This extended excerpt explores the problem, the approach and the outcome with practical examples drawn from Netfotech's delivery work across BFSI, healthcare, manufacturing and government.",
        readTime: "12 min",
        author: "Netfotech BFSI Practice",
        date: "2025-07-04",
    },
    {
        id: "r-digital-twins",
        type: "Report",
        category: "Manufacturing",
        title: "State of Digital Twins 2026: adoption, ROI and pitfalls",
        summary:
            "A cross-sector report covering 80+ digital-twin deployments what's actually shipping, where ROI compounds, and the three failure patterns we see most often.",
        content: "A cross-sector report covering 80+ digital-twin deployments what's actually shipping, where ROI compounds, and the three failure patterns we see most often. Full article body is published at netfotech.in. This extended excerpt explores the problem, the approach and the outcome with practical examples drawn from Netfotech's delivery work across BFSI, healthcare, manufacturing and government.",
        readTime: "10 min",
        author: "Netfotech Industry Desk",
        date: "2025-12-01",
    },
];

export const JOBS = [
    { id: "j1", title: "Senior ML Engineer", location: "Bengaluru / Remote", type: "Full-time", team: "AspireX", experience: "5–8 years" },
    { id: "j2", title: "Cloud Solution Architect", location: "Hyderabad", type: "Full-time", team: "Cloud & DevOps", experience: "7–10 years" },
    { id: "j3", title: "Cybersecurity Consultant", location: "Mumbai / Remote", type: "Full-time", team: "SecureGrid", experience: "4–7 years" },
    { id: "j4", title: "Product Designer (3D/Motion)", location: "Remote", type: "Contract", team: "Product", experience: "3–6 years" },
    { id: "j5", title: "Data Engineer", location: "Pune", type: "Full-time", team: "Data Platform", experience: "3–6 years" },
    { id: "j6", title: "Engagement Manager — BFSI", location: "Mumbai", type: "Full-time", team: "Consulting", experience: "8–12 years" },
    { id: "j7", title: "IT Recruiter", location: "Kolkata", type: "Full-time", team: "Talent Acquisition", experience: "0–3 years" },
    { id: "j8", title: "Node.js Developer", location: "Pune", type: "Full-time", team: "Engineering", experience: "2–5 years" },
];

export const TRUST_LOGOS = [
    "Aster Health", "Kotak FinServ", "Reliance Retail", "Hindalco", "DHL Ops",
    "BITS Pilani", "GovIndia", "TataSteel", "Paytm", "Axis Capital",
];

export const STATS = [
    { label: "Years of proven delivery", value: "9+" },
    { label: "Enterprises served", value: "140+" },
    { label: "Global offices", value: "11" },
    { label: "Service practices", value: "7" },
];

// Tech partners — real Netfotech alliance partners list.
export const TECH_PARTNERS = [
    { name: "Microsoft", category: "Cloud & Enterprise" },
    { name: "AWS", category: "Cloud" },
    { name: "Google Cloud", category: "Cloud" },
    { name: "SAP", category: "Enterprise" },
    { name: "Oracle", category: "Enterprise" },
    { name: "Adobe", category: "Experience" },
    { name: "Salesforce", category: "CX" },
    { name: "Veeva CRM", category: "Life Sciences" },
    { name: "Pega", category: "Automation" },
    { name: "Blue Yonder", category: "Supply Chain" },
    { name: "Opencart", category: "Commerce" },
    { name: "Databricks", category: "Data" },
    { name: "Snowflake", category: "Data" },
    { name: "MongoDB", category: "Data" },
    { name: "Kubernetes", category: "Platform" },
    { name: "OpenAI", category: "AI" },
    { name: "Anthropic", category: "AI" },
    { name: "CrowdStrike", category: "Security" },
];

export const TESTIMONIALS = [
    {
        id: "t1",
        quote:
            "Netfotech rebuilt our fraud intelligence stack in 9 months the kind of outcome most partners promise and never deliver.",
        name: "Ananya Rao",
        role: "Chief Digital Officer",
        org: "top 10 Retail Bank",
    },
    {
        id: "t2",
        quote:
            "Their clinical AI copilot didn't just compress our ER triage times it earned trust from physicians on day one.",
        name: "Dr. Vikram Shah",
        role: "CMIO",
        org: "Multi-hospital Network",
    },
    {
        id: "t3",
        quote:
            "A senior partner was accountable through every phase. That's rare, and it's why we extended the engagement to three more plants.",
        name: "Priya Iyer",
        role: "VP Smart Manufacturing",
        org: "Global Industrial Major",
    },
    {
        id: "t4",
        quote:
            "Zero trust rollout across 120M citizens with 99.99% uptime Netfotech are now our long term technology partner.",
        name: "R. Venkatesan",
        role: "Secretary, Digital Services",
        org: "National Government",
    },
];

// Home services showreel: small muted stock video loop (Pexels, CC0).
// onError fallback in <ServicesShowreel> degrades to the poster image.
export const SERVICES_SHOWREEL = {
    video:
        "https://videos.pexels.com/video-files/3129957/3129957-uhd_2560_1440_30fps.mp4",
    poster:
        "https://images.pexels.com/photos/3184292/pexels-photo-3184292.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    caption: "A glimpse of how we engineer AI, cloud and secure platforms across industries.",
};

// About — Leadership (photos removed per latest brief; uses monogram avatars)
export const LEADERSHIP = [
    {
        id: "l-arindam",
        name: "Arindam Ghosh",
        role: "Founder & CEO",
        bio: "Seasoned technology executive with extensive experience leading enterprise software organizations, shaping product and business strategy, and driving organizational growth.",
    },
    {
        id: "l-shalini",
        name: "Shalini N",
        role: "Chief Human Resource Officer",
        bio: "HR leader with strong expertise in scaling global teams, driving culture transformation, and building high-performance, people-centric organizations.",
    },
    {
        id: "l-amit",
        name: "Amit Gupta",
        role: "Global Delivery Head",
        bio: "Delivery leader with proven expertise in global operations, execution excellence, and building high performing engineering teams across complex technology programs.",
    },
    {
        id: "l-rohan",
        name: "Rohan Banerji",
        role: "Chief AI Officer",
        bio: "Leading enterprise grade AI innovation and large scale production deployments across key industries. Recognized for building high performing AI teams and delivering transformative automation solutions.",
    },
];

// About — Journey (compact narrative)
export const TIMELINE = [
    {
        year: "2017",
        title: "The Beginning",
        desc: "Founded with a vision to blend engineering excellence with customer-centric delivery.",
    },
    {
        year: "2018",
        title: "Early Growth",
        desc: "Expanded capabilities and secured long term clients across Europe and the Middle East.",
    },
    {
        year: "2019",
        title: "New Markets",
        desc: "Entered the US and European markets and strengthened offshore delivery operations.",
    },
    {
        year: "2020",
        title: "Digital Acceleration",
        desc: "Supported clients with cloud migration, remote workforce solutions and rapid digital adoption.",
    },
    {
        year: "2021",
        title: "Managed Services & Global Presence",
        desc: "Launched the Managed Services Division and expanded internationally with new locations in London and Johannesburg.",
    },
    {
        year: "2022",
        title: "Enterprise Delivery & New Hubs",
        desc: "Delivered large scale projects across industries while expanding to Bangalore and Wyoming.",
    },
    {
        year: "2023",
        title: "Technology Leadership",
        desc: "Invested in automation frameworks, intelligent workflows and data engineering.",
    },
    {
        year: "2024",
        title: " AI driven Solutions & India Expansion",
        desc: "Introduced early AI products and opened new offices in Kolkata and Gurgaon.",
    },
    {
        year: "2025",
        title: "AI Transformation",
        desc: "Accelerated the AI roadmap with LLMs, predictive analytics, computer vision and advanced automation.",
    },
    {
        year: "2026",
        title: "Iterative AI & New Locations",
        desc: "Launched Iterative AI our dedicated AI innovation arm — and expanded to Dehradun, Nagpur, Goa and Jaipur.",
    },
    {
        year: "Today",
        title: "A Global Technology & AI Ecosystem",
        desc: "A multi disciplinary global technology company with strong engineering teams, a growing AI product suite, and a culture built on professionalism, accountability and innovation.",
    },
];

// About — Global presence (synced with Contact details)
export const LOCATIONS = [
    { city: "Pune", country: "India", type: "HQ", note: "World Trade Center, Kharadi" },
    { city: "Kolkata", country: "India", type: "Delivery Center" },
    { city: "Gurgaon", country: "India", type: "Sales & APAC Hub" },
    { city: "Bangalore", country: "India", type: "Delivery Center" },
    { city: "Dehradun", country: "India", type: "R&D Center" },
    { city: "Nagpur", country: "India", type: "Delivery Center" },
    { city: "Goa", country: "India", type: "Branch" },
    { city: "Jaipur", country: "India", type: "Branch" },
    { city: "Wyoming", country: "USA", type: "Sales & Delivery" },
    { city: "London", country: "UK", type: "Sales & Delivery" },
];

// About — Culture & values
export const VALUES = [
    { icon: "Compass", title: "Aspire high", desc: "We choose hard problems and bold customer outcomes  not vanity metrics." },
    { icon: "Users", title: "Team over ego", desc: "Craft is collective. Feedback is a gift. Nobody outranks a good idea." },
    { icon: "ShieldCheck", title: "Trust by default", desc: "Security, privacy and honesty are non-negotiable  internally and with customers." },
    { icon: "Sparkles", title: "Craft matters", desc: "We ship work we'd sign with our name. Good is the enemy of great." },
    { icon: "Globe2", title: "Global, grounded", desc: "We operate across 18 countries but stay close to the user on the ground." },
    { icon: "TrendingUp", title: "Compound learning", desc: "Every engagement makes our next one sharper a 10-year learning curve, every year." },
];

// About — Certifications & Compliance
export const CERTIFICATIONS = [
    { code: "ISO 27001", name: "Information Security Management" },
    { code: "ISO 9001", name: "Quality Management" },
    { code: "SOC 2 Type II", name: "Service Organization Controls" },
    { code: "HIPAA", name: "US Healthcare Data Compliance" },
    { code: "GDPR", name: "EU Data Protection Readiness" },
    { code: "DPDP Act", name: "India Data Protection Compliance" },
    { code: "CMMI Level 5", name: "Capability Maturity Model" },
    { code: "PCI-DSS", name: "Payment Card Industry Data Security" },
];
